var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhitePlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33537 0.123185C1.47758 0.0418346 1.6387 -0.000647869 1.80254 7.46865e-06C1.96637 0.000662806 2.12715 0.0444329 2.2687 0.126918L16.909 8.66692L12.3786 12.7437L0.866837 2.38372V0.933318C0.866702 0.768989 0.909956 0.607536 0.992226 0.465283C1.0745 0.323031 1.19287 0.205021 1.33537 0.123185Z",
    fill: "#F1F3F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.866837 4.89636V23.1038L10.9842 14.0001L0.866837 4.89636Z",
    fill: "#F1F3F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.866837 25.6163V27.0667C0.866788 27.231 0.910071 27.3923 0.992316 27.5344C1.07456 27.6766 1.19285 27.7945 1.33525 27.8763C1.47765 27.9581 1.63912 28.0009 1.80334 28.0003C1.96756 27.9998 2.12873 27.9559 2.27057 27.8731L16.909 19.3331L12.3786 15.2563L0.866837 25.6163Z",
    fill: "#F1F3F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6021 18.3455L24.6688 14.8063C24.8098 14.7241 24.9268 14.6064 25.0081 14.4649C25.0894 14.3234 25.1322 14.1631 25.1322 13.9999C25.1322 13.8367 25.0894 13.6764 25.0081 13.5349C24.9268 13.3934 24.8098 13.2757 24.6688 13.1935L18.6021 9.6543L13.773 13.9999L18.6021 18.3455Z",
    fill: "#F1F3F4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePlay);
export default __webpack_public_path__ + "static/media/white-play.45bc0f36600d7ae4c34c8bcac0b71407.svg";
export { ForwardRef as ReactComponent };